<iframe
  #playableWidget
  scrolling="no"
  marginheight="0"
  marginwidth="0"
  frameborder="0"
  class="playable__widget"
  style="display: none; order: none; padding: 0; margin: 0; overflow: hidden"
  allowTransparency="true"
  data-responsive="true"
  [style.display]="isLoading ? 'none' : 'block'"
>
</iframe>

<div *ngIf="isLoading" class="card loading">
  <div class="card__image">
    <figure></figure>
  </div>
</div>
